<template>
	<component
		:is="PageComponent"
		v-if="PageComponent"
		:slug="slug"
		:unique-product-name="slug"
	/>
</template>

<script setup lang="ts">
import { ref, defineAsyncComponent } from "vue";
import type { Component } from "vue";

const route = useRoute();
const { resolveSlug } = useNorcePwa();
const { localeProperties } = useI18n();
const slug = encodeURIComponent(route.params.slug as string) || "";
const { data, error } = await useAsyncData(
	`resolveSlug-${slug}`,
	() =>
		resolveSlug({
			slug: slug as string,
			cultureCode: localeProperties.value.iso as string
		}),
	{
		lazy: false
	}
);
const type = (data.value?.type as string) || "";
if (error.value) {
	console.error("Error resolving slug:", error.value);
}

const PageComponent = ref<Component | null>(null);
if (type === "product") {
	PageComponent.value = defineAsyncComponent(
		() => import("./product/[uniqueProductName]/index.vue")
	);
} else if (type === "category") {
	PageComponent.value = defineAsyncComponent(
		() => import("./category/[...slug].vue")
	);
} else {
	PageComponent.value = defineAsyncComponent(
		() => import("./cms/[...slug].vue")
	);
}
</script>
